import firebase from "gatsby-plugin-firebase";
import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import FileBox from '../components/FileBox'
import {Spin} from 'antd';



const Files = () => {
  
  const [uploadedFiles, setFiles]  = React.useState([]);

  const getFiles = () => {
    var storageRef = firebase.storage().ref();

    var generatedRef = storageRef.child('generated');

    var list = generatedRef.list({maxResults: 100});
    list.then(res => {
      Promise.all(res.items.map(async file => {
        file.url = await file.getDownloadURL();
        return file
      })).then(files => setFiles(files));
    })
    console.log("Pulling Files");
    
  }

  React.useEffect(() => {
    getFiles();
  },[])


  return (
    <Layout>
    <SEO title="Files" />
    <FileBox files={uploadedFiles}></FileBox>
   
    
    </Layout>
)
}

export default Files;